// Данные → «В план заказа» (Алексей 27.10 #2972; открыта 05.11 #4459, собрание всего «чего не хватило» — #4464):
// звук, отзывы, голос, недопродажи по чекам, выкладка, визиты — со ссылками в разделы «Данных» и цитатами.
import useSWR from 'swr';
import { Check, Lightbulb, Minus } from 'lucide-react';
import { ServerStatusNotice } from '@/components/common/ServerStatusNotice';
import { Card, CardContent } from '@/components/ui/card';
import { getOrderPlan, type OrderPlanDto } from '@/api/orderPlan';
import { useT } from '@/contexts/I18nContext';
import { cn } from '@/lib/utils';
import { OrderPlanBlock } from './OrderPlanBlock';

/** Панель в Статусе скрыта до доработки (Алексей 27.10 #2990/#2991); вкладка в «Данных» — открыта (05.11 #4459). */
export const ORDER_PLAN_READY = false;

/** Какие источники подключены — одной строкой. */
function Sources({ s }: { s: OrderPlanDto['sources'] }) {
  const { t } = useT();
  const items: [boolean, string][] = [
    [s.mic, t('orderPlan.source.mic')],
    [s.reviews_maps, t('orderPlan.source.reviewsMaps')],
    [s.review_form, t('orderPlan.source.reviewForm')],
    [!!s.receipts, t('orderPlan.source.receipts')],
    [!!s.visits, t('orderPlan.source.visits')],
  ];
  return (
    <div className="mb-3 flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
      <span>{t('orderPlan.sources')}:</span>
      {items.map(([on, label]) => (
        <span key={label} className={cn('inline-flex items-center gap-1 rounded-full border px-2 py-0.5', on ? 'border-primary/30 text-foreground' : 'border-border opacity-70')}>
          {on ? <Check className="size-3 text-primary" /> : <Minus className="size-3" />}
          {label}
        </span>
      ))}
    </div>
  );
}

export default function OrderPlanTab({ zoneId, from, to }: { zoneId: string; from: string; to: string }) {
  const { t } = useT();
  const { data, error, isLoading } = useSWR(zoneId ? ['analytics:order-plan', zoneId, from, to] : null,
    () => getOrderPlan(zoneId, from, to).then((r) => r.data), { revalidateOnFocus: false });
  return (
    <Card>
      <CardContent className="px-4 py-4">
        <div className="mb-2 text-xs text-muted-foreground">{t('orderPlan.intro')}</div>
        {/* Совет про голос — только когда микрофон есть (без него совет «подключить микрофон» ниже, в блоке). */}
        {data?.sources.mic && (
          <div className="mb-3 flex items-start gap-2 rounded-lg bg-muted/50 px-3 py-2 text-sm">
            <Lightbulb className="mt-0.5 size-4 shrink-0 text-primary" />
            <span className="min-w-0 flex-1">{t('orderPlan.voiceTip')}</span>
          </div>
        )}
        {data && <Sources s={data.sources} />}
        {isLoading && !data && <div className="h-32 animate-pulse rounded-lg bg-muted" />}
        {error && !data && <ServerStatusNotice variant="card" error={error} />}
        {data && <OrderPlanBlock data={data} zoneId={zoneId} />}
      </CardContent>
    </Card>
  );
}
